import { render, staticRenderFns } from "./newArrival.vue?vue&type=template&id=7aedfca6&"
import script from "./newArrival.vue?vue&type=script&lang=js&"
export * from "./newArrival.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports